import React from 'react';
import SEO from './SEO';

interface PageTitleProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  type?: string;
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ 
  title,
  description,
  keywords,
  image,
  type,
  publishedTime,
  modifiedTime,
  author,
  section
}) => {
  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      image={image}
      type={type}
      publishedTime={publishedTime}
      modifiedTime={modifiedTime}
      author={author}
      section={section}
    />
  );
};

export default PageTitle;